/* global TweenMax CDN */
import React, { Component } from 'react';
import StageActions from '../../actions/StageActions';
import { isMobile, isPhone, isIOS } from '../../lib/isMobile';
import { sendEvent } from '../../lib/analytics';

const mobile = isMobile();

const propTypes = {
    paused: React.PropTypes.bool,
    // media: React.PropTypes.shape({
    //     src: React.PropTypes.string.isRequired,
    // }).isRequired,
    preload: React.PropTypes.string,
    canMute: React.PropTypes.bool,
    name: React.PropTypes.string.isRequired,
    onEnd: React.PropTypes.func,
};

const defaultProps = {
    paused: false,
    preload: 'auto',
    canMute: true,
    onEnd: null,
};

const contextTypes = {
    store: React.PropTypes.object,
    language: React.PropTypes.string,
    masterVolume: React.PropTypes.number,
};

class VideoPlayer extends Component {

    constructor(props) {
        super(props);

        this.videoElement = null;
        this.playButtonElement = null;

        this.onTogglePlay = this.onTogglePlay.bind(this);

        this.changeVolume = this.changeVolume.bind(this);
        this.mute = this.mute.bind(this);
        this.unMute = this.unMute.bind(this);

        this.end = this.end.bind(this);

        const hideButton = isPhone() && isIOS();

        this.state = {
            playing: false,
            clickedOnce: false,
            hideButton,
            tracked: false,
        };
    }

    componentDidMount() {
        this.setState({
            masterVolume: this.context.masterVolume,
        });

        this.videoElement.addEventListener('play', this.mute);
        this.videoElement.addEventListener('playing', this.mute);

        this.videoElement.addEventListener('pause', this.unMute);
        this.videoElement.addEventListener('error', this.unMute);
        this.videoElement.addEventListener('ended', this.end);
    }

    componentDidUpdate(prevProps, prevState) {
        const { playing, tracked } = this.state;
        const { paused, name } = this.props;

        const playingChanged = prevState.playing !== playing;
        const pausedChanged = prevProps.paused !== paused;
        const trackedChanged = prevState.tracked !== tracked;

        if (playingChanged && this.videoElement !== null) {
            // console.log('playchanged', playing);
            if (playing) {
                this.videoElement.play();
            } else {
                this.videoElement.pause();
            }
            this.animateButton();
        }

        if (pausedChanged) {
            this.unMute();
            this.setState({
                playing: false,
            });
        }

        if (trackedChanged) {
            if (prevState.tracked === false) {
                sendEvent('video', `play_${name}`);
            }
        }
    }

    componentWillUnmount() {
        if (this.videoElement !== null) {
            this.videoElement.pause();
        }

        this.videoElement.removeEventListener('play', this.mute);
        this.videoElement.removeEventListener('playing', this.mute);

        this.videoElement.removeEventListener('pause', this.unMute);
        this.videoElement.removeEventListener('error', this.unMute);
        this.videoElement.removeEventListener('ended', this.end);
    }

    changeVolume(volume) {
        const { paused, canMute } = this.props;
        const canChangeMasterVolume = !paused && canMute;
        if (canChangeMasterVolume) {
            this.context.store.dispatch(StageActions.setMasterVolume(volume));
        }
    }

    mute() {
        this.changeVolume(0);
    }

    unMute() {
        const { canMute } = this.props;
        const { masterVolume } = this.state;
        if (canMute) {
            this.context.store.dispatch(StageActions.setMasterVolume(masterVolume));
        }
    }

    end() {
        if (this.props.onEnd !== null) {
            this.props.onEnd();
        }
        this.unMute();
    }

    onTogglePlay(e) {
        e.stopPropagation();
        if (this.videoElement !== null) {
            this.setState({
                playing: !this.state.playing,
                tracked: true,
            });
        }
    }

    animateButton() {
        TweenMax.to(this.playButtonElement, 1, {
            alpha: this.state.playing ? 0 : 1,
        });
    }

    render() {
        const { language } = this.context;
        const { preload, name } = this.props;
        // const { hideButton } = this.state;

        const type = mobile ? 'mobile' : 'desktop';

        const urls = {
            jpg: `${CDN}/video/jpg/${name}-${language}.jpg`,
            webm: `${CDN}/video/webm/${type}/${name}-${language}.webm`,
            mp4: `${CDN}/video/mp4/${type}/${name}-${language}.mp4`,
            ogv: `${CDN}/video/ogv/${type}/${name}-${language}.ogv`,
        };

        return (
            <div key={`${name}-${language}`} className="real-content video-container">
                <video
                    preload={preload}
                    poster={urls.jpg}
                    ref={(el) => { this.videoElement = el; }}
                    onClick={this.onTogglePlay}
                >
                    <source
                        src={urls.mp4}
                        type="video/mp4"
                    />
                    <source
                        src={urls.webm}
                        type="video/webm"
                    />
                    <source
                        src={urls.ogv}
                        type="video/ogv"
                    />
                Votre navigateur ne permet pas de lire les vidéos HTML5.
                </video>
                <button
                    className="video-play-button"
                    ref={(el) => { this.playButtonElement = el; }}
                    onClick={this.onTogglePlay}
                />
            </div>
        );
    }
}

VideoPlayer.propTypes = propTypes;
VideoPlayer.defaultProps = defaultProps;
VideoPlayer.contextTypes = contextTypes;

module.exports = VideoPlayer;



// WEBPACK FOOTER //
// ./js/components/partials/VideoPlayer.jsx